/**
 * Display confirm quit game pop-up.
 * @param state current state of the game
 */
import { IGameState } from '../../../../../src/State/Game/IGameState';

export function showQuitGamePopup(state: IGameState): IGameState {
    return state
}
